import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';
import { IconType } from '../../components/atoms/icon/icon';
import formTeamsContent from './formTeamsContent';
// import formSportRoomConfigContentMassUpdate from './formSportRoomConfigContentMassUpdate';
export default {
  attributeName: 'eventsTable',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: false,
  canRemove: false,
  isMultiSelectable:false,
  newButton:true,
  editURL:'teams/appId',
  getURL:'teams/appId',
  updateURL:'teams/appId',
  removeURL:'teams/appId',
  deleteRecordText:"You are about to delete a team. Are you totally sure?",
  popupContentFormNew:[formTeamsContent],
  popupContentFormEdit:[formTeamsContent],
  // popupContentFormSecondary:[formSportRoomConfigContentMassUpdate],
  sessionParams: ['appId'],

  emptyMessage: "You don't have any graphic manifest on this manager, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'enable',
      label: 'Enable',
      type: FormInputTypes.CHECKBOX,
      default: '',
      canOrder: false,
      canEdit: true,
      canCreate: false,
      canFilter: false,
      helpText: 'If this event is enabled to be sent or not.',
    },
    {
      attributeName: 'eventType',
      label: 'Event type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canEdit: false,
      canCreate: false,
      canFilter: false,
      helpText: 'Type of event from sportsradar.',
    },
     {
      attributeName: 'effectType',
      type: FormInputTypes.SELECT,
      label: 'Effect type',
      helpText: 'Type of effect to be displayed on the headset',
      errorText: '',
      default:[1],
      width: '16rem',
      options: [
        {name:'Stats', value: 'stats'},
        { name: 'Sparks', value: 'sparks' },
        { name: 'Confetti', value: 'confetti' },
        { name: 'Fire', value: 'fire' },
        { name: 'Jumpball', value: 'jumpball' },
        { name: 'Red light', value: 'redlight' },
        { name: 'Sync', value: 'sync'},
        { name: 'Timeout', value: 'timeout' },
      ],
      canOrder: false,
      canEdit: true,
      canFilter: false,
      canCreate: true,
    },         
  ],
};
